// extracted by mini-css-extract-plugin
export default {"p_tye":"_8b0bc2ff21","slcted":"_019a52a895","slc_color":"_290636b0a9","item_p":"_80daf59bf1","r0":"_0ab428f222"};